export default {
    alert: {
        ready: `준비중입니다 :-)`
    },
    footer: {
        address: `〒07528 서울시 강서구 양천로401 강서한강자이타워 A동 704, 705호 <br class="under-tablet-break">CubePlatform ㅣ 대표자 : 김상우`,
        copyright: `Copyright ⓒ 2020 All Rights Reserved by CubePlatform`
    },
    main: {
        visual: {
            desc01: `다국어를 기반으로 한 <br>'글로벌 이커머스 플랫폼 솔루션' 제공`,
            desc02: `큐브플랫폼 자사 솔루션 도입을 통한 <br>안정된 글로벌 네트워크를 구축`,
            desc03: `영리한 시스템과 첨단 장비 도입으로 <br>오차 없이 정확하고 <br>빠른 풀필먼트 플랫폼`,
            desc04: `이커머스에 특화된 <br>다국어 컨택센터 서비스를 제공`
        },
        about: {
            desc: `진보된 이커머스 플랫폼 <br>'큐브플랫폼'`
        },
        business: {
            desc: `큐브플랫폼은 직구, 역직구 사업에 필요한 <br class="under-tablet-break">진보된 솔루션을 제공합니다`,
            section01: {
                desc: `국가, 언어, 화폐의 경계를 허무는 <br>글로벌 이커머스 플랫폼을 개발합니다.`
            },
            section02: {
                desc: `자사 개발 시스템을 <br>도입하여, 안정된 글로벌 네트워크를 <br>구축해 나가고 있습니다.`
            },
            section03: {
                desc: `자사의 풀필먼트 시스템을 <br>도입하여, 안정된 글로벌 네트워크를 <br>구축해 나아가고 있습니다.`
            },
            section04: {
                desc: `글로벌 고객의 상품 문의, 반품, 환불 등 <br>모든 커뮤니케이션을 큐브플랫폼이 <br>대행해드립니다.`
            }
        },
        globalnetwork: {
            desc: `큐브플랫폼은 글로벌 이커머스 <br>서비스 전문 기업으로 <br>국내를 넘어 일본, 독일에 이르는 <br>글로벌 네트워크를 보유하고 있습니다`
        }
    },
    about: {
        title: `진보된 이커머스 플랫폼 <br class="under-tablet-break">'큐브플랫폼'`,
        desc: `이커머스 시장은 하루가 다르게 <br class="under-tablet-break">글로벌화되고 있습니다. <br><br>큐브플랫폼은 국가와 언어, 화폐의 장벽을 허무는 <br class="under-tablet-break">글로벌 <br class="desktop-break">이커머스 플랫폼, 솔루션을 <br class="under-tablet-break">개발, 발전시켜 나아가고 있습니다. <br><br class="under-tablet-break">전세계 60억 인구의 시장을 완벽하게 <br class="under-tablet-break">하나로 만드는 이커머스 플랫폼 개발이 <br class="under-tablet-break">큐브플랫폼의 궁극적인 목표입니다.`,
        section01: {
            title: `조직구성`,
            team01: {
                main: `이커머스 플랫폼 사업부`,
                sub01: `플랫폼 기획팀`,
                sub02: `플랫폼 개발팀`,
                sub03: `플랫폼 디자인팀`
            },
            team02: {
                main: `로지스틱스 사업부`,
                sub01: `큐브 기획팀`,
                sub02: `큐브 영업팀`,
                sub03: ``
            },
            team03: {
                main: `컨택센터`,
                sub01: `한국어팀`,
                sub02: `일본어팀`,
                sub03: `영어팀`
            }
        },
        section02: {
            desc01: `택배 박스를 상징`,
            desc02: `이커머스 플랫폼을 상징`
        },
        section03: {
            address: `〒07528 서울시 강서구 양천로401<br class="under-tablet-break">강서한강자이타워 A동 704, 705호`
        }
    },
    business: {
        desc: `큐브플랫폼은 직구, 역직구 사업에 <br>필요한 진보된 솔루션을 제공합니다. <br>솔루션, 물류, 커뮤니케이션 걱정 없이 <br>전세계 60억 시장에 <br class="desktop-break">진출하실 수 있습니다.`,
        section01: {
            sub01: {
                title: `이커머스 <br class="under-tablet-break">플랫폼 개발`,
                subTitle: `이커머스 <br>플랫폼 개발`,
                desc: `<strong class="first">글로벌 이커머스 플랫폼</strong>
                        <p>국가, 언어, 화폐의 경계를 허무는 글로벌<br class="under-tablet-break">
                        이커머스 플랫폼을 개발하여 <br class="desktop-break">
                        직구, 역직구에<br class="under-tablet-break">
                        필요한 웹/모바일 솔루션을 파트너사에 <br class="under-tablet-break">공급합니다. <br class="desktop-break">파트너사가 상품의 소싱,<br class="under-tablet-break">마케팅에만 더욱 집중할 수 있게 해드립니다.</p><strong>이커머스 물류 플랫폼</strong><p>이커머스에 특화된 물류 플랫폼으로 재고 관리,<br class="under-tablet-break">입고, 출고 기능은 물론 <br class="desktop-break">전세계 주요 이커머스<br class="under-tablet-break">솔루션과의 재고, 주문 동기화까지 가능합니다.</p>`,
                linkTitle: ``,
                link: ``
            },
            sub02: {
                title: `글로벌 <br class="under-tablet-break">이커머스 물류 <br class="under-tablet-break">서비스`,
                subTitle: `글로벌 이커머스 <br>물류 서비스`,
                desc: `<p>큐브플랫폼은 자사 개발 시스템을 도입하여, 안정된 <br>글로벌 네트워크를 구축해 나가고 있습니다. <br>파트너사들은 현지에 진출하지 않고도 효율성 높은<br>물류 서비스를 이용하실 수 있습니다.</p>`,
                linkTitle: ``,
                link: ``
            },
            sub03: {
                title: `글로벌 <br class="under-tablet-break">풀필먼트(3PL) <br class="under-tablet-break">서비스`,
                subTitle: `글로벌 <br>풀필먼트(3PL) <br>서비스`,
                desc: `<p>자사의 풀필먼트 시스템을 도입하여, 안정된 글로벌 <br class="under-tablet-break">네트워크를 구축해 나아가고 있습니다. <br class="desktop-break">재고관리를 <br class="under-tablet-break">통한 풀필먼트 서비스는 물론, 재고를 두지 않는 <br class="under-tablet-break">배송대행 서비스도 가능합니다. <br class="desktop-break">파트너사들은 <br class="under-tablet-break">현지에 진출하지 않고도 효율성 높은 물류 서비스를 <br class="under-tablet-break">이용하실 수 있습니다.</p>`,
                linkTitle: `LOGISBIZ 바로가기`,
                link: `http://logisbiz.co.kr/`
            },
            sub04: {
                title: `다국어 <br class="under-tablet-break">컨택센터 서비스`,
                subTitle: `다국어 <br>컨택센터 서비스`,
                desc: `<p>글로벌 고객의 상품 문의, 반품, 환불 등 모든 <br class="under-tablet-break">커뮤니케이션을 큐브플랫폼이 대행해드립니다. <br><br>서비스 가능 컨택센터 : <br class="under-tablet-break">한국어, 일본어, 영어 컨택센터</p>`,
                linkTitle: ``,
                link: ``
            }
        }
    },
    globalnetwork: {
        title: `혁신적인 글로벌 이커머스 서비스의 <br class="under-tablet-break">중심 큐브플랫폼`,
        desc: `큐브플랫폼은 한국을 시작으로 일본,독일까지 <br class="under-tablet-break">글로벌 네트워크를 구축하고 있으며, <br class="under-tablet-break">전세계 60억 인구가사용할 수 있는 <br class="desktop-break">글로벌 이커머스 서비스로 <br class="under-tablet-break">도약하기 위해 더 많은 시장 진출을 앞두고 있습니다.`,
        section01: {
            center01: {
                title: `한국 서울(SEOUL) 센터`,
                desc: `〒07528 서울시 강서구 양천로401<br class="under-tablet-break">강서한강자이타워 A동 704, 705호`
            },
            center02: {
                title: `일본 도쿄(TOKYO) 센터`,
                desc: `千葉県船橋市南海神1-7-4 船橋FLC 4階, TOKYO, JAPAN`
            },
            center03: {
                title: `독일 프랑크푸르트(FRA) 센터`,
                desc: `PHILIPP-REIS-STARßE 363486 BRUCHKÖBEL`
            },
            center04: {
                title: `영국(UK) 센터`,
                desc: `DC4, IMPERIAL ROAD, RYTON ON DUNSMORE, COVENTRY, <br class="under-tablet-break">CV8 3LF, UNITED KINGDOM`
            }
        }

    },
    recruit: {
        desc01: `상식을 기반으로 발전하는 <br class="desktop-break">‘큐브플랫폼’ 입니다.`,
        desc02: `큐브플랫폼은 현실에 <span>안주하지 않고 성장</span>하고자 노력합니다.<br>큐브플랫폼은 <span>차별화된 서비스</span>를 추구합니다.<br>큐브플랫폼은 <span>부당한 차별</span>과 <span>부당한 회사 문화</span>가 없습니다.<br>큐브플랫폼은 <span>실적과 효율성</span>을 높여 구성원과 <span>성과를 공유</span>합니다.`,
        section01: {
            title: `큐브플랫폼 복지`,
            desc1: `연 1회 일본<br class="desktop-break">왕복 항공권 제공`,
            desc2: `보증금 1,000만원<br class="desktop-break">무이자 대출`,
            desc3: `생일 오전 근무<br class="desktop-break">+ 생일 선물`,
            desc4: `종합 건강검진<br class="desktop-break">연 1회 제공<br><span>(본인 또는 직계가족)</span>`,
            desc5: `이사 지원금<br class="desktop-break">지급`,
            desc6: `사내 복지 포인트 지원<br><span>(해외 직구 쇼핑용)</span>`,
            desc7: `팀별 문화 생활비 <br class="desktop-break">지원`,
            desc8: `도서 구입비 <br class="desktop-break">지원`,
            desc9: `자기개발비 <br class="desktop-break">지원`,
            desc10: `사내 카페 <br class="desktop-break">운영`,
            desc11: `한국, 일본의<br class="desktop-break">간식 무한대 제공`,
            desc12: `듀얼 모니터 + <br class="desktop-break">macOS <br class="under-tablet-break">또는 Windows 택일`
        },
        section02: {
            title: `모집분야 자세히 보기`,
            modal: {
                title: `모집분야`,
                desc: `도전적인 정신으로 큐브플랫폼과 <br class="under-tablet-break">글로벌 서비스를 만들어갈 인재를 모십니다.`,
                category01: `플랫폼 개발`,
                category02: `플랫폼 디자인`,
                category03: `로지스틱스 사업부`,
                category04: `컨텍센터`,
                site01: `잡코리아 지원하기`,
                site02: `사람인 지원하기`
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/translations/locales/kr.js